// extracted by mini-css-extract-plugin
export default {"backdrop":"Loading_backdrop__pnBpf","main":"Loading_main__mamW2","loader":"Loading_loader__6nbWa","spinner":"Loading_spinner__+rAeO"};